import classes from "./FillLines.module.css";

interface Props {
  rows: number;
}

/**
 * Evenly spaced blank write-in rules that stretch to fill their container,
 * whatever height it is given.
 */
const FillLines = ({ rows }: Props): JSX.Element => (
  <div className={classes.lines}>
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className={classes.line} />
    ))}
  </div>
);

export default FillLines;
